import React, { useEffect, useState } from 'react';
import { List, Divider, Spin, Empty } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import api from '../api.js';

export default function DashboardNotifications({ onClose, open }) {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);
  const { t } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {

    if (open) {
      fetchNotifications();
    }

  }, [open]);

  const fetchNotifications = async () => {
    try {

      setLoading(true);
      const res = await api.get('/notifications/my');
      setNotifications(res.data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleClick = async (item) => {
    try {
      await api.put(`/notifications/read/${item.id}`);

      if (item.type === 'message') {
        navigate('/dashboard/messages');
      }

      fetchNotifications();
      if (onClose) onClose(); // ferme dropdown
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div style={{ width: 320, background: '#fff', borderRadius: 10 }}>
      <div style={{ padding: 10, fontWeight: 600 }}>
        {t("notifications")}
      </div>

      <Divider style={{ margin: 0 }} />

      {loading ? (
        <div style={{ padding: 20, textAlign: 'center' }}>
          <Spin />
        </div>
      ) : notifications.length === 0 ? (
        <div style={{ padding: 20 }}>
          <Empty description={t("noNotifications")} />
        </div>
      ) : (
        <List
          dataSource={notifications}
          renderItem={(item) => (
            <List.Item
              onClick={() => handleClick(item)}
              style={{
                cursor: 'pointer',
                background: item.isRead ? '#fff' : '#f5f5f5',
                padding: 12
              }}
            >
              <List.Item.Meta
                title={item.title}
                description={item.message}
              />
              {!item.isRead && (
                <span style={{
                  width: 8,
                  height: 8,
                  background: 'red',
                  borderRadius: '50%'
                }} />
              )}
            </List.Item>
          )}
        />
      )}
    </div>
  );
}